import { createFileRoute } from '@tanstack/react-router';
import { TextKey } from '@mews-commander/enums';
import { GoLiveContainer } from '@mews-commander/modules/src/modules/onboardingGoLive';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/OnboardingGoLive/$targetEnterpriseId')({
    beforeLoad: ({ context: { checkPlatformPrivilege } }) => {
        checkPlatformPrivilege('manageEnterprises');
    },
    component: Component,
    staticData: {
        title: TextKey.OnboardingGoLiveContainerBreadcrumb,
        owner: MewsTeam.Connectivity,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { targetEnterpriseId } = Route.useParams();

    return <GoLiveContainer enterpriseId={targetEnterpriseId} />;
}
